(function () {
  var STORAGE_KEY = 'em_wishlist_product_ids';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function isSaved(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggle(productId) {
    productId = String(productId);
    var ids = getWishlist();
    var index = ids.indexOf(productId);
    if (index === -1) {
      ids.push(productId);
    } else {
      ids.splice(index, 1);
    }
    saveWishlist(ids);
    return ids;
  }

  function updateButtonState(button) {
    var productId = button.getAttribute('data-product-id');
    var saved = isSaved(productId);
    button.classList.toggle('is-active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
    updateHeaderCount();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button.getAttribute('data-product-id'));
    refreshAll();
  });

  document.addEventListener('DOMContentLoaded', refreshAll);
})();
